import { Standards } from "./Standards.component";

export { Standards };
